module.exports = __webpack_public_path__ + "assets/img/2231591947409_.pic_hd.0b1d1e28.jpg";